import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';

const AssessmentPage = lazy(() => import('./pages/AssessmentPage'));
const PatientListPage = lazy(() => import('./pages/PatientListPage'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const PricingPage = lazy(() => import('./pages/PricingPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
const LandingPage = lazy(() => import('./pages/LandingPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage'));
const EULAPage = lazy(() => import('./pages/EULAPage'));
const ComplianceCenterPage = lazy(() => import('./pages/ComplianceCenterPage'));
const LoginPage = lazy(() => import('./components/LoginPage').then(m => ({ default: m.LoginPage })));
const UpgradeModal = lazy(() => import('./components/UpgradeModal').then(m => ({ default: m.UpgradeModal })));
const ConsentSignPage = lazy(() => import('./pages/ConsentSignPage'));

/** Inner component so it can call hooks that depend on PlanContext */
function AppInner() {
  return (
    <>
      <Toaster position="top-right" richColors closeButton />
      <Suspense fallback={null}>
        <UpgradeModal />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>Loading...</div>}>
        <Routes>
          {/* Public marketing landing page — shown before login */}
          <Route path="/" element={<LandingPage />} />

          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/eula" element={<EULAPage />} />

          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <PatientListPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings/compliance"
            element={
              <AdminRoute>
                <ComplianceCenterPage />
              </AdminRoute>
            }
          />

          <Route
            path="/assessment/:patientId?"
            element={
              <ProtectedRoute>
                <AssessmentPage />
              </ProtectedRoute>
            }
          />

          {/* Public consent self-sign page — no auth required */}
          <Route path="/consent/:token" element={<ConsentSignPage />} />
        </Routes>
      </Suspense>
    </>
  );
}

function App() {
  return <AppInner />;
}

export default App;
